export default __webpack_public_path__ + "static/media/dino_NORMAL.91f0b9c8.png";